


























































































































import { Component, Mixins, Prop } from 'vue-property-decorator';

import { ConfigFormData } from '@/models/onboarding';
import { IBusinessType } from '@/models/business';
import { StartGuideTask } from '@/models/start-guide';

import { validation as formValidate } from '@/views/Onboarding/Steps/LoyaltySetup/validation';
import { configFormDataFactory } from '@/views/Onboarding/helpers';
import LoyaltySetupBase from '@/views/Onboarding/Steps/LoyaltySetup/LoyaltySetupBase.vue';

import LoyaltyExample from '@/components/molecules/LoyaltyExample/LoyaltyExample.vue';
import LoyaltyConfigForm from '@/components/organisms/LoyaltyConfigForm/LoyaltyConfigForm.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import InfoIcon from '@/components/icons/Info.vue';
import flagKeys from '@/constants/flagKeys';
import RewardsProgramCommon from '../RewardsProgramCommon.vue';
import SellCoinsService from '@/api/SellCoinsService';
import PercentageCircleIcon from '@/components/icons/PercentageCircle.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Radio from '@/components/molecules/Radio/Radio.vue';
import CoinsIcon from '@/components/icons/Coins.vue';

@Component({
  components: {
    LoyaltyConfigForm,
    FilledButton,
    LoyaltyExample,
    InfoIcon,
    PercentageCircleIcon,
    Typography,
    Radio,
    CoinsIcon
  }
})
export default class RewardRatio extends Mixins(
  RewardsProgramCommon,
  LoyaltySetupBase
) {
  @Prop() task!: StartGuideTask;
  IBusinessType = IBusinessType;
  formData: ConfigFormData = this.formDataStore || configFormDataFactory();
  sellCoinsService = new SellCoinsService();
  loading: boolean = false;
  stepRatioIssue: boolean = false;
  // Starts empty on purpose: the merchant has to pick one of the two options.
  // Pre-marking the destructive one let a single click on Next switch Sell
  // Coins off without the merchant ever choosing it (TWISM-19426).
  optionSelected: string = '';
  activeCampaign: any = {
    name: '',
    incentiveValue: ''
  };

  // Only the ratio-issue step carries the radios. Without this guard an empty
  // choice reaches RefundPolicy, where `!sellCoinsAction` means "the modal never
  // showed up" and a campaign gets created that nobody asked for (TWISM-19426).
  get nextIsBlocked() {
    return this.stepRatioIssue && !this.optionSelected;
  }

  get isValidForm() {
    return formValidate(this.formData);
  }

  get formDataStore() {
    const { rewardRatio = undefined } = this.rewardsProgramFormData;

    return rewardRatio;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get imgUrl() {
    return require(`@/assets/img/reward-onboarding/circle-arrow-right.png`);
  }

  get redirectToSlugBack() {
    if (
      this.businessInfo.type === IBusinessType.INSTORE ||
      this.businessInfo.type === IBusinessType.BOTH
    ) {
      const providersList =
        this.$store.getters['merchant/getProvidersList'] || [];
      const connectedProviders = providersList
        .filter((provider: any) => provider && provider.name !== 'fidel')
        .filter((provider: any) => provider && provider.connected);

      if (!connectedProviders.length) {
        return this.ERewardsProgramStepSlug.OPERATION_POS_SYSTEM;
      }
    }

    return this.ERewardsProgramStepSlug.INTRODUCTION;
  }

  isDashboardSellCoinsAndLoyaltVerify() {
    return this.flags.includes(flagKeys.dashboardSellCoinsAndLoyaltVerify);
  }

  handleChangeFormData(formData: ConfigFormData) {
    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      rewardRatio: formData
    });

    this.formData = formData;
  }

  async onSubmit() {
    this.loading = true;

    if (!this.isValidForm) {
      this.$notification('Please select an option', 'error');
      this.loading = false;

      return;
    }

    const payload = {
      coinPurchaseRatio: this.coinPurchaseRatio,
      coinRewardPercentage: this.percentInCoins,
      sellCoinsAction: this.stepRatioIssue ? this.optionSelected : null
    };

    const response = await this.sellCoinsService.getActiveCampaign();
    const campaign = response.data;
    this.activeCampaign = campaign;

    if (
      !this.stepRatioIssue &&
      this.businessInfo.sellCoins &&
      this.isDashboardSellCoinsAndLoyaltVerify() &&
      this.percentInCoins &&
      ((campaign.incentiveValue &&
        this.percentInCoins.toFixed() > campaign.incentiveValue) ||
        campaign.incentiveValue === 0)
    ) {
      this.stepRatioIssue = true;
      this.loading = false;
      return;
    }

    this.$store.dispatch('rewardsProgram/SET_REWARD_RATIO_PAYLOAD', payload);

    this.$emit('goToStep', {
      redirectToSlug: this.ERewardsProgramStepSlug.REFUND_POLICY
    });
    this.loading = false;
  }
}
